import { dataUrlBase64, readFileDataUrl, validateUpload } from "./legalLetters";

const CATALOGUE_TYPES = ["application/pdf", "image/jpeg", "image/png"];
const MAX_CATALOGUE_BYTES = 5 * 1024 * 1024;

export function validateCatalogueUpload(file) {
  if (!file) return "Choose a PDF, JPEG or PNG file.";
  if (!CATALOGUE_TYPES.includes(file.type)) return "Choose a PDF, JPEG or PNG file.";
  // Keep the shared validator as the source for the established 5 MB limit.
  return validateUpload(file, "attachment") || (file.size > MAX_CATALOGUE_BYTES ? "Files must be 5 MB or smaller." : "");
}

export async function catalogueAttachment(file) {
  const error = validateCatalogueUpload(file);
  if (error) throw new Error(error);
  const dataUrl = await readFileDataUrl(file);
  const data = dataUrlBase64(dataUrl);
  if (!data) throw new Error("Could not read this file.");
  return { filename: file.name, content_type: file.type, data };
}

export function catalogueFileKind(contentType) {
  if (contentType === "application/pdf") return "pdf";
  if (contentType === "image/jpeg" || contentType === "image/png") return "image";
  return "unknown";
}

export function isValidEmailAddress(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
}

export function canShareCatalogue(globalRole, companyRole) {
  const globalName = String(globalRole || "").trim().toLowerCase();
  const companyName = String(companyRole || "").trim().toLowerCase();
  return !!companyName && globalName !== "viewer" && companyName !== "viewer";
}